/**
 * General function to clean up any strings from API that are substandard.
 *
 * ? Add to this list over time as necessary
 *
 * @param {string} string - the input string
 * @returns {string}
 */
function cleanUpApiString(str) {
  let outputStr = str;

  switch (str) {
    case "Financial Accreditation Reports":
      outputStr = "Financial Accreditation";
      break;
    case "Financial Agreed Upon Procedures Reports":
      outputStr = "Financial Agreed-Upon Procedures";
      break;
    case "Financial or Single Audit Reports":
      outputStr = "Financial / Single Audit";
      break;
    case "Other Reports":
      outputStr = "Other";
      break;
    case "Performance Audit Reports":
      outputStr = "Performance Audit";
      break;
  }

  return outputStr;
}

export default cleanUpApiString;
